import React, { useEffect, useState } from "react";
import { Bell, BellOff, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function SubscribeButton({ threadId, initialSubscription }) {
  const { user } = useAuth();
  const [sub, setSub] = useState(initialSubscription || null);

  useEffect(() => { setSub(initialSubscription || null); }, [initialSubscription, threadId]);

  if (!user) return null;

  const subscribe = async (muted = false) => {
    try {
      const { data } = await api.post(`/threads/${threadId}/subscribe`, { muted });
      setSub({ muted: data.muted });
      toast.success(muted ? "خاموش کر دیا (کوئی اطلاع نہیں)" : "سبسکرائب کر لیا");
    } catch { toast.error("ناکام"); }
  };
  const unsubscribe = async () => {
    try {
      await api.delete(`/threads/${threadId}/subscribe`);
      setSub(null);
      toast.success("ان سبسکرائب");
    } catch { toast.error("ناکام"); }
  };

  if (!sub) {
    return (
      <Button size="sm" variant="outline" onClick={() => subscribe(false)} className="gap-1.5 font-eng" data-testid="subscribe-btn">
        <Bell size={14} /> <span className="urdu-naskh">اطلاع لیں</span>
      </Button>
    );
  }
  if (sub.muted) {
    return (
      <div className="inline-flex gap-1">
        <Button size="sm" variant="outline" onClick={() => subscribe(false)} className="gap-1.5" data-testid="unmute-btn">
          <Bell size={14} /> <span className="urdu-naskh">آواز چالو</span>
        </Button>
        <Button size="sm" variant="ghost" onClick={unsubscribe} data-testid="unsub-btn"><span className="urdu-naskh">ان سبسکرائب</span></Button>
      </div>
    );
  }
  return (
    <div className="inline-flex gap-1">
      <Button size="sm" variant="default" onClick={() => subscribe(true)} className="bg-primary gap-1.5" data-testid="mute-btn">
        <BellOff size={14} /> <span className="urdu-naskh">خاموش کریں</span>
      </Button>
      <Button size="sm" variant="ghost" onClick={unsubscribe} data-testid="unsub-btn">
        <Check size={14} /> <span className="urdu-naskh">سبسکرائبڈ</span>
      </Button>
    </div>
  );
}
